import React from 'react';
import { useCall } from '../../contexts/CallContext';
import VideoCall from '../VideoCall';
import IncomingCall from '../IncomingCall';
import { useAuth } from '../../contexts/AuthContext';

const GlobalCallOverlay = () => {
  const { user } = useAuth();
  const { activeCall, incomingCall, handleAcceptCall, handleRejectCall, endCall } = useCall();

  if (!user) return null;

  return (
    <>
      {activeCall && (
        <VideoCall 
          call={activeCall} 
          currentUserId={user.id} 
          partner={activeCall.participant || activeCall.caller} 
          onEnd={endCall} 
        />
      )}
      {incomingCall && !activeCall && (
        <IncomingCall 
          incomingCall={incomingCall} 
          onAccept={handleAcceptCall} 
          onReject={handleRejectCall} 
        />
      )}
    </>
  );
};

export default GlobalCallOverlay;
